import request from '@/utils/request';


export default {
    // 获取报告期限
    getSelector: (param) => {
        return request({
            url: `/rmc/produce/medicineUsage/getSelector`,
            method: 'post',
        });
    },
    // 药品用量查询
    getMedicineUsage: (param) => {
        return request({
            url: `/rmc/produce/medicineUsage/queryPage`,
            method: 'post',
            data:param
        });
    },
    // 详情页面保存
    saveMedicineUsage: (param) => {
        return request({
            url: `/rmc/produce/medicineUsage/save`,
            method: 'post',
            data:param
        });
    },
    // 提交
    submitMedicineUsage: (param) => {
        return request({
            url: `/rmc/produce/medicineUsage/submit`,
            method: 'post',
            data:param
        });
    },
    // 查询详情
    medicineUsageDetail: (id) => {
        return request({
            url: `/rmc/produce/medicineUsage/queryDetail/${id}`,
            method: 'post',
        });
    },
    // 删除
    deleteMedicineUsage: (param) => {
        return request({
            url: `/rmc/produce/medicineUsage/delete`,
            method: 'post',
            data:param
        });
    },
    // 保存行项目
    saveAmount: (param) => {
        return request({
            url: `/rmc/produce/medicineUsage/saveAmount`,
            method: 'post',
            data:param
        });
    },
    // 删除行项目
    deleteAmount: (param) => {
        return request({
            url: `/rmc/produce/medicineUsage/deleteAmount`,
            method: 'post',
            data:param
        });
    },
    // 获取作物
    getFarmName: (rmcProduceFarmId) => {
        return request({
            url: `/rmc/produce/medicineUsage/getCropSelectorByFarmName/${rmcProduceFarmId}`,
            method: 'post',
        });
    },
    // 导出
    exportMedicineUsage: (param) => {
        return request({
            url: `/rmc/produce/medicineUsage/exportMedicineUsage`,
            method: 'post',
            data:param,
            responseType: "blob",
            fullResponse: true,
        });
    },
    // 导入模板
    importExcelTemp: (param) => {
        return request({
            url: `/rmc/produce/medicineUsage/importExcelForProduceMedicineUsageTemp`,
            method: 'get',
            data:param,
            responseType: "blob",
            fullResponse: true,
        });
    },
    // 首页批量提交
    submitData: (params) => {
        return request({
            url: `/rmc/produce/medicineUsage/submit`,
            method: 'post',
            data:params
        });
    },
}



